import React, { useRef, useEffect, useState, useCallback } from "react"
import { mainAxios, setAuthToken, confirmLoginCompany, needsLoginCompanyConfirmation, toCompanyId } from '../../services/mainAxios'
import { TransitionGroup, CSSTransition } from "react-transition-group"
import { useAppContext } from '../../AppContext'
import func from "../../services/functions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faEye, faEyeSlash, faPaperPlane, faSyncAlt } from "@fortawesome/free-solid-svg-icons"
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from './react-simple-captcha'
import { useTranslation, withTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import ForgetPassword from "./ForgetPassword"
import { toast } from "react-toastify"
import OtpInput from "react-otp-input"

import authLogo from '../../design/assets/lock-icon1.svg'
import PopOver from "../global/PopOver"
import moment from "moment"
import useKeycloack from "./useKeycloack"
import Loader from "../Layout/Loader"
import axios from "axios"
import googleLogo from '../../design/assets/google-icon.svg'
import microsoftLogo from '../../design/assets/microsoft-logo.svg'
import './Auth.scss'
import Select from "react-select"
import { customStyles, errorSelectStyle } from "../../design/selectStyle"
import { FinanceIllustration, FloatingShapes } from "./LoginIllustrations"

// Simple countdown hook
const useCountDown = (initialTime = 60000, interval = 1000) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isRunning, setIsRunning] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (isRunning && timeLeft > 0) {
            intervalRef.current = setInterval(() => {
                setTimeLeft(prev => Math.max(0, prev - interval));
            }, interval);
        }
        return () => clearInterval(intervalRef.current);
    }, [isRunning, interval, timeLeft]);

    const start = useCallback((newTime) => {
        setTimeLeft(newTime !== undefined ? newTime : initialTime);
        setIsRunning(true);
    }, [initialTime]);

    const pause = useCallback(() => setIsRunning(false), []);
    const resume = useCallback(() => setIsRunning(true), []);
    const reset = useCallback(() => {
        setTimeLeft(initialTime);
        setIsRunning(false);
    }, [initialTime]);

    return [timeLeft, { start, pause, resume, reset }];
};



const NewLogin = (props) => {
    const { t, i18n } = useTranslation('translations');
    const [username, setUsername] = React.useState("")
    const [password, setPassword] = React.useState("")
    const [passwordType, setPasswordType] = React.useState("password")
    const { user: [user, setUser], selectedCompany: [selectedCompany, setSelectedCompany] } = useAppContext()
    const [forget, setForget] = React.useState(false);
    const [showProviders, setShowProviders] = React.useState(true);
    const defaultState = {
        loggingUser: false,
        userIsLoggedIn: user ? true : false,
        error: null,
        selectedCompany: 0,
        token: null,
        user: user,
        otpSent: 0,
        otpCode: "",
        mfaOptions: [],
        otpJwt: null,
        attempts: 3,
        otpSendLoading: false
    }

    const initialTime = 60 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000;  // interval to change remaining time amount, defaults to 1000

    const [state, setState] = React.useState(defaultState)
    const [captchaState, setCaptchaState] = React.useState({
        captcha: "",
        canLogin: false,
        error: null
    })


    const [timeLeft, { start, pause, resume, reset }] = useCountDown(initialTime, interval);

    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    const restart = React.useCallback(() => {
        const newTime = 180 * 1000;
        start(newTime);
    }, []);


    const handleCaptchaChange = (e) => {
        const captcha = e.target.value
        setCaptchaState(captchaState => ({
            ...captchaState,
            captcha
        }))
    }
    React.useLayoutEffect(() => {
        const resetCaptchaLink = document.querySelector("#reload_href")
        if (!resetCaptchaLink) return
        resetCaptchaLink.innerHTML = `
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="sync-alt"
                class="svg-inline--fa fa-sync-alt fa-w-16 "
                role="img" xmlns="http://www.w3.org/2000/svg"
                viewbox="0 0 512 512">
                <path
                    fill="currentColor"
                    d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z">
                </path>
            </svg>
        `
        loadCaptchaEnginge(6);
    }, [state?.userIsLoggedIn])

    const onLogin = (response, fromOtp) => {
        let content = fromOtp ? response.data.content[0] : response.data
        const token = content.token || content.jwttoken
        setAuthToken(token)
        let fullUser = content.fullUser
        // Check the last reload date from localStorage

        const lastReloadDate = localStorage.getItem("lastReloadDate");
        const today = moment().format("YYYY-MM-DD");
        const checkCompany = fullUser.companiesRights.some(companyRight=>companyRight.authProviderAllowed &&( companyRight.id ==parseInt(selectedCompany)))

        const confirmationNeeded = needsLoginCompanyConfirmation(fullUser)

        if (selectedCompany && checkCompany) {
            func.setCookie("token", token)
            const refreshToken = response?.headers?.["refresh-token"] || content.keycloakRefreshToken
            if (refreshToken) {
                func.setCookie("refreshToken", refreshToken)
                setAuthToken(refreshToken, "Refresh-Token")
            }
            if (confirmationNeeded) {
                confirmLoginCompany({ company: selectedCompany, token })
            }
            props.history?.replace("/")
            setUser(fullUser)
            if (lastReloadDate !== today) {
                localStorage.setItem("lastReloadDate", today);
                window.location.reload(true);
            }
        }
        else {
            func.setCookie("token", token)
            const refreshToken = response?.headers?.["refresh-token"] || content.keycloakRefreshToken
            if (refreshToken) {
                func.setCookie("refreshToken", refreshToken)
                setAuthToken(refreshToken, "Refresh-Token")
            }
            setState(state => ({
                ...state,
                loggingUser: false,
                userIsLoggedIn: true,
                error: null,
                token: token,
                user: fullUser,
                confirmationNeeded
            }))
        }
    }



    const sendOtp = () => {
        setState((state) => ({
            ...state,
            otpSendLoading: true
        }))

        mainAxios.post('public/generateOtp?mfa=' + state.mfa, {
            username,
        })
            .then((res) => {
                restart()
                setState((state) => ({
                    ...state,
                    otpSendLoading: false
                }))
                if (res.data.status == true) {
                    toast.success("Otp was sent successfully", {
                        containerId: "all_toast",
                    });
                    setState((state) => ({
                        ...state,
                        otpSent: state.otpSent + 1
                    }))
                }
            })
    }
    const otpVerification = (value) => {
        mainAxios.post('/public/validateOtp?otp=' + value, {
            username,
            company: toCompanyId(selectedCompany),
        })
            .then((res) => {
                if (res?.data?.status == true) {
                    setState((state) => ({
                        ...state,
                        otpJwt: null,
                        otpCode: "",
                    }))
                    onLogin(res, true)
                } else {
                    if (res.data?.content?.length == 0) {
                        reset()
                        return
                    }
                    setState((state) => ({
                        ...state,
                        attempts: res?.data?.content[0].attempts
                    }))
                }
            })
    }

    const handleLogin = ({keycloakCode,showCaptcha=true}={}) => {
        const captchaNeeded = (process.env.REACT_APP_CAPTCHA === "false" || showCaptcha==false) ? false : true
        if ((captchaNeeded && validateCaptcha(captchaState.captcha.toLowerCase())) || !captchaNeeded) {
            setCaptchaState(captchaState => ({
                ...captchaState,
                error: null
            }))
            setState(state => ({
                ...state,
                keycloakCode,
                loggingUser: true
            }))


            const companyHint = toCompanyId(selectedCompany)

            let body={
                username,
                password,
                isAgent: 0,
                webLogin: true,
                company: companyHint
            }

            if(keycloakCode){
                body={
                    keycloakCode,
                    company: companyHint
                }
            }
            const baseUrl= process.env.REACT_APP_JAVA_SERVER_URL
            axios.post(baseUrl+"public/authenticate",body).then(res => {
                if (res.status === 200) {
                    if (!res?.data?.otpJwt) {
                        setState(state => ({
                            ...state,
                            loggingUser: false,
                        }))
                        onLogin(res)
                    } else if (res?.data?.otpJwt) {
                        setState(state => ({
                            ...state,
                            loggingUser: false,
                            otpJwt: res?.data?.otpJwt,
                            mfaOptions: res?.data?.mfaList,
                            mfa: res?.data?.mfa ?? "EMAIL"
                        }))
                        setAuthToken(res.data.otpJwt)
                    }
                }
                else if (res?.response?.status === 423) {
                    setState(state => ({
                        ...state,
                        loggingUser: false,
                        userIsLoggedIn: false,
                        error: t(['toast.manyAttemps'])
                    }))
                }
                else {
                    setState(state => ({
                        ...state,
                        loggingUser: false,
                        userIsLoggedIn: false,
                        error:res?.faultReason?? t(['toast.invalidCredentials'])
                    }))
                }
            })
                .catch(err => {
                    console.log({err})
                    setState(state => ({
                        ...state,
                        loggingUser: false,
                        userIsLoggedIn: false,
                        error:err?.response?.data?.faultReason ?? t(['toast.invalidCredentials'])
                    }))
                })
            loadCaptchaEnginge(6);
        }
        else {
            setCaptchaState(captchaState => ({
                ...captchaState,
                error: t(['toast.captchaError']),
                captcha: ""
            }))
        }
    }
    const { googleUrl,microsoftUrl } = useKeycloack({handleLogin,onLogin})

    const goToLogin = () => {
        setState(state => ({
            ...state,
            loggingUser: false,
            userIsLoggedIn: false,
            error: null,
            otpJwt: null
        }))
    }

    const handleSelectedCompany = (selectedCompany) => {
        setState(state => ({
            ...state,
            selectedCompany:selectedCompany?selectedCompany.toString():null
        }))
    }

    const onCompanySelected = () => {
        if (state.selectedCompany !== 0) {
            setAuthToken(state.token)
            func.setCookie("token", state.token)
            if (state.confirmationNeeded) {
                confirmLoginCompany({ company: state.selectedCompany, token: state.token })
            }
            setSelectedCompany(state.selectedCompany)
            props.history?.replace("/")
            setUser({
                ...state.user
            })
            setState(state => ({
                ...state,
                confirmationNeeded: false,
                error: null
            }))
        }
        else {
            setState(state => ({
                ...state,
                error: t('login.chooseCompanyError')
            }))
        }
    }
    const handleOtpCodeChange = (e) => {
        if (e.length == 4) otpVerification(e)
        setState((state) => ({ ...state, otpCode: e }))
    }

    // if(state?.keycloakCode && state?.loggingUser){
    //     return
    // }


    return (
        <div>
        {state?.keycloakCode && state?.loggingUser && <div className="d-flex justify-content-center align-items-center" style={{position:"absolute",top:0,bottom:0,right:0,left:0,zIndex:9999,backgroundColor:"white"}}>
            <Loader label={t('login.loggingIn')}/>
        </div>}
        <div className="overflow-hidden">
            <TransitionGroup component={null}>
                {
                    !forget && !state.userIsLoggedIn && !state?.otpJwt &&
                    // false&&
                    <CSSTransition
                        timeout={400}>
                        <div className="authincation d-flex">
                            <div className="login-aside login-aside-modern text-center d-flex flex-column flex-row-auto">
                                <FloatingShapes />
                                <div className="d-flex flex-column-auto flex-column fade-in-effect" style={{position: 'relative', zIndex: 2}}>
                                    <div className="text-center mb-3 mb-md-5 pt-0 pt-md-5" onDoubleClick={()=>setShowProviders(true)}>
                                        <img src="/new-logo-profisc-white.png" alt="" style={{width:"280px", height:"90px"}} />
                                    </div>
                                    <h2 className="mb-4 text-center text-white">{t('login.slogan')}</h2>
                                </div>
                                <div className="aside-illustration">
                                    <FinanceIllustration />
                                </div>
                            </div>

                            <div
                                className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-4 p-md-7 mx-auto">
                                <div className="d-flex justify-content-center h-100 align-items-center">
                                    <div className="auth-form-container">
                                    <form onSubmit={(e) => { e.preventDefault(); handleLogin() }}>
                                        <h3 className="auth-form-title">
                                            {t('navbar.login')}
                                        </h3>
                                        {state.error && (
                                            <div className="error-message">
                                                {state.error}
                                            </div>
                                        )}

                                        <div className="form-group">
                                            <label htmlFor="username">
                                                {t('users.username')}
                                            </label>
                                            <input
                                                type="text"
                                                className={"form-control" + (state.error ? " border-danger" : "")}
                                                id="username"
                                                placeholder={t('users.username')}
                                                value={username}
                                                autoComplete="new-password"
                                                onChange={(e) => setUsername(e.target.value)}
                                                required />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="password">
                                                {t('users.password')}
                                            </label>
                                            <div className="password-input-wrapper">
                                                <input
                                                    type={passwordType}
                                                    className={"form-control" + (state.error ? " border-danger" : "")}
                                                    id="password"
                                                    placeholder={t('users.password')}
                                                    value={password}
                                                    autoComplete="new-password"
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required />
                                                <span
                                                    className="password-toggle"
                                                    onClick={() => setPasswordType(passwordType === "password" ? "text" : "password")}>
                                                    <FontAwesomeIcon icon={passwordType === "password" ? faEye : faEyeSlash} />
                                                </span>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="d-flex align-items-center justify-content-center gap-2 w-100">
                                                <LoadCanvasTemplate />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{ flex: 1, padding: '0.375rem 0.5rem' }}
                                                    value={captchaState.captcha}
                                                    onChange={handleCaptchaChange} />
                                            </div>
                                            {captchaState.error && (
                                                <div className="error-message">
                                                    {captchaState.error}
                                                </div>
                                            )}
                                        </div>

                                        <div className="form-actions">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={state.loggingUser}>
                                                {state.loggingUser ? <Loader size="xs" color="white" /> : t('navbar.login')}
                                            </button>
                                        </div>

                                        <div className="form-links">
                                            <Link onClick={() => setForget(true)} to={"/forget-password"}>
                                                {t("common.forgotPassword")}
                                            </Link>
                                        </div>

                                        {showProviders && (
                                            <div className="mt-3">
                                                <div className="authenticate">
                                                    <div className="or">{t('login.or')}</div>
                                                    <div className="authenticators-list">
                                                        <a href={googleUrl} className="authenticator-container">
                                                            <img src={googleLogo} width={25} height={25}/>
                                                        </a>
                                                        <a href={microsoftUrl} className="authenticator-container">
                                                            <img src={microsoftLogo} width={25} height={25}/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                }

                {forget && <ForgetPassword />}

            </TransitionGroup>
            <TransitionGroup component={null}>
                {
                    state.otpJwt &&
                    // true &&
                    <CSSTransition
                        className="otp-container"
                        timeout={300}>
                        <div className="otp-container">
                            <div className="otp-login-section mt-3 w-md-100">
                                <img className="auth-logo" src={authLogo} />
                                <h3 className="send-sms-message">{state.otpSent > 0 ? t("invoice.verifysms") : t("invoice.sendsms")}</h3>
                                {state.otpSent > 0 && (
                                    <div className="d-flex mt-4">
                                        <OtpInput
                                            isInputNum={true}
                                            value={state.otpCode}
                                            className=""
                                            onChange={handleOtpCodeChange}
                                            numInputs={4}
                                            inputStyle="otp-input"
                                        />
                                    </div>
                                )}
                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        className={`btn btn-primary shadow mb-2 mt-4`}
                                        onClick={sendOtp}
                                        disabled={state.otpSendLoading || (state.otpSent > 0 && minutes >= 2 && minutes > 0)}
                                    >
                                        <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
                                        {state.otpSent > 0 ? t("invoice.resendCode") : t("invoice.send")}
                                    </button>
                                    <div className="mt-4">
                                        <PopOver title={t("hints.otpHint")} />
                                    </div>
                                </div>
                                <div className="d-flex mt-3">
                                    <div className="text-muted mr-4">{state.attempts} {t("invoice.attemtpsLeft")}</div>
                                    <div className="time-countdown text-danger"> {minutes}:{seconds < 10 ? "0" + seconds : seconds}</div>
                                </div>

                            </div>
                        </div>
                    </CSSTransition>
                }
            </TransitionGroup>

            <TransitionGroup component={null}>
                {state?.userIsLoggedIn &&
                    <CSSTransition
                        timeout={400}>

                        <div className="authincation d-flex">
                            <div className="login-aside login-aside-modern text-center d-flex flex-column flex-row-auto">
                                <FloatingShapes />
                                <div className="d-flex flex-column-auto flex-column" style={{position: 'relative', zIndex: 2}}>
                                    <a href="#" className="go-back go-back-modern" onClick={(e) => { e.preventDefault(); goToLogin() }}>
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                    </a>
                                    <div className="text-center mb-5 pt-5 logo-badge">
                                        <img src="/Logo-Profisc-2.png" alt="" style={{width:"280px", height:"90px"}} />
                                    </div>
                                    <h2 className="mb-4 text-center text-white">{t('login.slogan')}</h2>
                                </div>
                            </div>

                            <div
                                className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
                                <div className="d-flex justify-content-center h-100 align-items-center">
                                    <div className="authincation-content style-2">
                                        <div className="row no-gutters">
                                            <div className="col-xl-12 tab-content">
                                                <div className="auth-form form-validation">
                                                    <form className="h-100 d-flex flex-column justify-content-between" onSubmit={(e) => { e.preventDefault(); onCompanySelected() }}>
                                                        <h1 className="text-center mb-4 text-black">
                                                            {t('company.selectCompany')}
                                                        </h1>

                                                        <div className="form-group position-relative">
                                                            <Select
                                                                options={state.user?.companiesRights ?? []}
                                                                value={state.user?.companiesRights.find(cR=>cR.id==state.selectedCompany)}
                                                                getOptionValue={opt=>opt.id}
                                                                getOptionLabel={opt=>opt.name}
                                                                onChange={(option) => {handleSelectedCompany(option.id) }}
                                                                styles={state.error?errorSelectStyle:customStyles}
                                                                isOptionDisabled={opt=>!opt.authProviderAllowed}
                                                            />
                                                        </div>
                                                        <div className="mt-3 form-text text-danger">
                                                            <p>{state.error ? state.error : ""}</p>
                                                        </div>
                                                        <div className="text-center form-group mb-3">
                                                            <button type="submit" className="btn submit btn-primary btn-block" value={t('company.continue')}>
                                                                {t('company.continue')}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </CSSTransition>
                }
            </TransitionGroup>
        </div>
        </div>
    )
}

export default NewLogin
